import { Component, EventEmitter, Input, Output } from '@angular/core';

interface LinearCardColumnConfig {
  color?: string;
  widthInPc?: string;
  fontWeight?: string;
}

@Component({
  selector: 'insight-linear-card',
  template: `
    <div class="linear-card" fxLayout="row" fxFlex>
      <!-- Icon and action cols -->
      <div
        *ngIf="iconColumnSrc"
        fxLayout="row"
        [fxFlex]="iconColumn.widthInPc"
        fxLayoutAlign="center center"
        class="content-wrapper"
      >
        <img [src]="iconColumnSrc" width="20" />
      </div>
      <div
        *ngIf="actionColumnText && actionToLeft"
        fxLayout="row"
        [fxFlex]="actionColumn.widthInPc"
        fxLayoutAlign="center center"
        class="content-wrapper"
      >
        <button class="custom-button" type="button" vrm-button (click)="triggerCardAction()">
          {{ actionColumnText | uppercase }}
        </button>
      </div>

      <!-- Text columns -->
      <div
        *ngIf="textColumnOne"
        fxLayout="row"
        [fxFlex]="columnOne.widthInPc"
        fxLayoutAlign="start center"
        class="content-wrapper"
      >
        <div [style.color]="columnOne.color" [style.font-weight]="columnOne.fontWeight">
          {{ textColumnOne }}
        </div>
      </div>
      <div
        *ngIf="textColumnTwo"
        fxLayout="row"
        [fxFlex]="columnTwo.widthInPc"
        fxLayoutAlign="start center"
        class="content-wrapper"
      >
        <div [style.color]="columnTwo.color" [style.font-weight]="columnTwo.fontWeight">
          {{ textColumnTwo }}
        </div>
      </div>
      <div
        *ngIf="textColumnThree"
        fxLayout="row"
        [fxFlex]="columnThree.widthInPc"
        fxLayoutAlign="start center"
        class="content-wrapper"
      >
        <div [style.color]="columnThree.color" [style.font-weight]="columnThree.fontWeight">
          {{ textColumnThree }}
        </div>
      </div>
      <div
        *ngIf="textColumnFour"
        fxLayout="row"
        [fxFlex]="columnFour.widthInPc"
        fxLayoutAlign="start center"
        class="content-wrapper"
      >
        <div [style.color]="columnFour.color" [style.font-weight]="columnFour.fontWeight">
          {{ textColumnFour }}
        </div>
      </div>
      <div
        *ngIf="textColumnFive"
        fxLayout="row"
        [fxFlex]="columnFive.widthInPc"
        fxLayoutAlign="start center"
        class="content-wrapper"
      >
        <div [style.color]="columnFive.color" [style.font-weight]="columnFive.fontWeight">
          {{ textColumnFive }}
        </div>
      </div>

      <!-- Action column - aligned right -->
      <div
        *ngIf="actionColumnText && !actionToLeft"
        fxLayout="row"
        fxLayoutAlign="center center"
        [fxFlex]="actionColumn.widthInPc"
        class="content-wrapper"
      >
        <button class="custom-button" vrm-button type="button" (click)="triggerCardAction()">
          {{ actionColumnText | uppercase }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .linear-card button {
        height: 29px;
      }
      .linear-card > div {
        background-color: white;
      }
      .content-wrapper {
        border-right: 1px solid #f1eded;
        border-bottom: 1px solid #f1eded;
        height: 40px;
      }
      .content-wrapper div {
        margin-left: 15px;
        margin-right: 15px;
      }
    `,
  ],
})
export class InsightLinearCardComponent {
  @Input() iconColumnSrc?: string;
  @Input() actionColumnText?: string;
  @Input() actionToLeft: boolean = false;
  @Output() actionEvent: EventEmitter<any> = new EventEmitter();

  @Input() textColumnOne: string;
  @Input() textColumnTwo?: string;
  @Input() textColumnThree?: string;
  @Input() textColumnFour?: string;
  @Input() textColumnFive?: string;

  @Input() iconColumn?: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };
  @Input() actionColumn?: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };

  @Input() columnOne: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };
  @Input() columnTwo: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };
  @Input() columnThree: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };
  @Input() columnFour: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };
  @Input() columnFive: LinearCardColumnConfig = { color: '', widthInPc: 'auto', fontWeight: '' };

  triggerCardAction() {
    this.actionEvent.emit();
  }
}
